import React from 'react';
import {omit} from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Modal from 'ui-library/modals/Modal';
import {worklistTypeDisplayName} from 'worklists/WorklistConstants';

import AddToWorklistForm, {
  AddToWorklistProps,
  WorklistFormSelectorType,
  useAddToWorklistForm,
} from './AddToWorklistForm';

export interface AddToWorklistModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

/**
 * Modal to add given items to a worklist. Assumes the caller has validated that the ids match the given
 * worklist type.
 */
export default function AddToWorklistModal({
  useFullWidthToggle = false,
  ...props
}: AddToWorklistProps & AddToWorklistModalProps): JSX.Element {
  const worklistFormProps = useAddToWorklistForm({...props, useFullWidthToggle});

  return (
    <Modal
      buttons={[
        {
          submit: true,
          text: 'Add items to worklist',
          disabled: worklistFormProps.isDisabled,
          dataTestAttrs: {component: 'AddToWorklistModal', element: 'addWorklistButton'},
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        worklistFormProps.addItems(props.ids);
        props.onRequestSubmit();
      }}
      title={`Add items to ${worklistTypeDisplayName(props.worklistType)} worklist`}
      titleIcon={ModelTypeConstants.WORKLIST}
    >
      <AddToWorklistForm
        {...omit(worklistFormProps, 'isDisabled', 'addItems')}
        {...props}
        useFullWidthToggle={useFullWidthToggle}
        selectorType={WorklistFormSelectorType.TOGGLE_GROUP}
      />
    </Modal>
  );
}
